import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

// IMPORTANT: QueryClient is created per-request (inside getRouter) so SSR
// never shares cached data between users. The defaults below apply to every
// useQuery in the app — keep responses cached for 30s and don't refetch on
// every window focus so back-navigation feels instant.
export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Preload route chunks + loader data on link hover/touchstart so clicks
    // feel instant. defaultPreloadStaleTime stays 0 so TanStack Query owns
    // freshness rather than Router's built-in preload cache.
    defaultPreload: "intent",
    defaultPreloadDelay: 50,
    defaultPreloadStaleTime: 0,
    // Avoid holding a spinner on already-cached navigations.
    defaultPendingMs: 200,
    defaultPendingMinMs: 0,
  });

  return router;
};
